import * as actionTypes from '../types/actionTypes'

const initialState = {
  data: [],
  world: []
}

const reducer = (state = initialState, action) => {
  // console.log('action type => ', action.type)
  switch (action.type) {
    case actionTypes.GRAPH_DATA:
      return {
        ...state,
        data: action.payload
      }
    case actionTypes.WORLD_DATA:
      return {
        ...state,
        world: action.payload
      }
    default:
      return state
  }
}

export default reducer
